<template>
  <v-container class="formulario-wrapper" fluid>
    <v-card class="elevation-2">

      <v-card-actions class="linhabuton pa-4">
        <v-row>
          <v-col cols="4" class="text-left">
            <v-btn color="error" outlined @click="excluir" v-if="!pedidoEnviado && pedidoDexieId">Excluir</v-btn>
          </v-col>
          
          <!-- <v-col cols="3" class="text-center">
            <v-btn color="primary" outlined dark @click="irParaImpressao">
              <v-icon left>mdi-printer</v-icon> PDF
            </v-btn>
          </v-col> -->

          <v-col cols="4" class="text-center"> 
            <v-btn text @click="cancelar" outlined>{{ pedidoEnviado ? 'Voltar' : 'Cancelar' }}</v-btn>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn :color="isOrcamento ? 'amber darken-2' : 'primary'" :class="isOrcamento ? 'white--text' : ''" @click="salvar" v-if="!pedidoEnviado">Salvar</v-btn>
          </v-col>
        </v-row>
    </v-card-actions>

    <v-divider class="divisor-secao"></v-divider>

      <v-card-text class="v-cardt">
        <v-form ref="form">
          <v-alert
            v-if="pedidoEnviado"
            type="info"
            dense
            outlined
            color="primary"
            class="mb-2"
          >
            Pedido Enviado
          </v-alert>

          <v-row class="align-center mt-2 mb-2" no-gutters>
            <v-col cols="auto">
              <v-switch
                v-model="isOrcamento"
                :disabled="pedidoEnviado" 
                inset
                hide-details
                class="mt-0 pt-0 ml-2"
                :class="{ 'switch-pedido-ativo': !isOrcamento }"
                color="amber darken-2"
              >
                <template v-slot:label>
                  <strong :class="!isOrcamento ? 'primary--text' : 'grey--text'">
                    PEDIDO
                  </strong>
                  <v-icon small class="mx-2">mdi-swap-horizontal</v-icon>
                  <strong :class="isOrcamento ? 'amber--text text--darken-2' : 'grey--text'">
                    ORÇAMENTO
                  </strong>
                </template>
              </v-switch>
            </v-col>

            <v-col>
              <v-divider class="divisor-secao ml-3"></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                :value="idPedidoExibicao"
                label="Pedido"
                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="formData.data"
                label="Data do Pedido"
                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-account-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              CLIENTE
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>

          <v-row align="center">
            <v-col class="col-codigo">
              <v-text-field
                v-model.number="formData.cliente" 
                label="Código do Cliente"
                outlined dense hide-details 
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('cliente')"
                @change="buscarCliente($event)"
                :readonly="pedidoEnviado"
                :error="formData.nomeCliente === 'Cliente não encontrado'"
              >
              </v-text-field>
            </v-col>
            <v-col class="col-botao pl-0 pr-2">
              <v-btn fab small :dark="!pedidoEnviado" :color="isOrcamento ? 'amber darken-2' : 'primary'" @click="pesquisarCliente" :disabled="pedidoEnviado">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-descricao">
              <v-text-field
                v-model="formData.nomeCliente"
                label="Nome do Cliente"
                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-4 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-credit-card-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              CONDIÇÕES DE PAGAMENTO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col class="col-codigo">
              <v-text-field
                v-model="formData.tipo"
                label="Tipo"
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('tipo')" outlined dense hide-details
                @change="buscarTipo($event, true)" :readonly="pedidoEnviado"
                :error="formData.descricaoTipo === 'Tipo não encontrado'">
              </v-text-field>
            </v-col>
            <v-col class="col-botao pl-0 pr-2">
              <v-btn fab small :dark="!pedidoEnviado" :color="isOrcamento ? 'amber darken-2' : 'primary'" @click="pesquisarTipo" :disabled="pedidoEnviado">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-descricao">
              <v-text-field v-model="formData.descricaoTipo" label="Descrição do Tipo" outlined dense hide-details readonly background-color="#FFF9C4"></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="col-codigo">
              <v-text-field
                v-model="formData.planoPagamento"
                label="Plano de Pagamento"
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('planoPagamento')" @change="buscarPlanoPagamento($event)"
                outlined dense hide-details
                :readonly="pedidoEnviado"
                :error="formData.descricaoPlanoPagamento === 'Plano não encontrado'">
              </v-text-field>
            </v-col>
            <v-col class="col-botao pl-0 pr-2">
              <v-btn fab small :dark="!pedidoEnviado" :color="isOrcamento ? 'amber darken-2' : 'primary'" @click="pesquisarPlanoPagamento" :disabled="pedidoEnviado">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-descricao">
              <v-text-field v-model="formData.descricaoPlanoPagamento" label="Descrição do Plano" outlined dense hide-details readonly background-color="#FFF9C4"></v-text-field>
            </v-col>
          </v-row>
          
          <v-row align="center">
            <v-col class="col-codigo">
              <v-text-field
                v-model="formData.formaPagamento"
                label="Forma de Pagamento"
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('formaPagamento')" outlined dense hide-details
                @change="buscarFormaPagamento($event)"
                :readonly="pedidoEnviado"
                :error="formData.descricaoFormaPagamento === 'Forma não encontrada'">
              </v-text-field>
            </v-col>
            <v-col class="col-botao pl-0 pr-2">
              <v-btn fab small :dark="!pedidoEnviado" :color="isOrcamento ? 'amber darken-2' : 'primary'" @click="pesquisarFormaPagamento" :disabled="pedidoEnviado">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-descricao">
              <v-text-field v-model="formData.descricaoFormaPagamento" label="Descrição da Forma" outlined dense hide-details readonly background-color="#FFF9C4"></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-4 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-information-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              OUTRAS INFORMAÇÕES
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col class="col-codigo">
              <v-text-field
                v-model="formData.destino"
                label="Destino"
                outlined
                dense
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('destino')" hide-details
                @change="buscarDestino($event)"
                :readonly="pedidoEnviado"
                :error="formData.descricaoDestino === 'Destino não encontrado'">
              </v-text-field>
            </v-col>
            <v-col class="col-botao pl-0 pr-2">
              <v-btn fab small :dark="!pedidoEnviado" :color="isOrcamento ? 'amber darken-2' : 'primary'" @click="pesquisarDestino" :disabled="pedidoEnviado">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-descricao">
              <v-text-field v-model="formData.descricaoDestino" label="Descrição do Destino" outlined dense hide-details readonly background-color="#FFF9C4"></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="pb-0">
              <v-textarea
                v-model="formData.observacao"
                label="Observação"
                outlined
                maxlength="250"
                counter="250"
                rows="4"
                class="mb-0"
              ></v-textarea>
            </v-col>
            <v-col cols="12" class="pt-0 mt-n2 d-flex justify-end">
              <v-btn
                small
                :color="isOrcamento ? 'amber darken-2' : 'primary'"
                :class="isOrcamento ? 'white--text' : ''"
                @click="importaCliente"
                :disabled="pedidoEnviado"
                style="font-size: 11px; height: 28px; text-transform: none;"
              >
                <v-icon left small>mdi-account-arrow-down-outline</v-icon>
                Importar Pré-Cadastro
              </v-btn>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-4 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              ITENS DO PEDIDO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center" class="my-1">
            <v-col cols="6" md="4">
              <v-btn
                block
                :color="isOrcamento ? 'amber darken-2' : 'primary'"
                :class="isOrcamento ? 'white--text' : ''"
                @click="adicionarItem"
                :disabled="pedidoEnviado"
                elevation="1"
                class="btn-adicionar-item text-none"
              >
                <v-icon left>mdi-plus</v-icon>
                Adicionar Item
              </v-btn>
            </v-col>

            <v-col cols="6" md="6">
              <v-text-field
                v-model="totalPedido"
                label="Total do Pedido"
                type="number"
                outlined dense hide-details readonly background-color="#FFF9C4"
                class="total-vermelho"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="itensPedidoAtivos.length > 0" class="mt-2">
            <v-col cols="12">
              <simplebar
                data-simplebar
                :autoHide="false"
                class="lista-itens-container elevation-1"
              >
                <v-list class="py-0" flat>
                  <template v-for="(item, index) in itensPedidoAtivos">
                    <v-list-item 
                      :key="item.id" 
                      class="px-3"
                      :link="!pedidoEnviado"
                      :ripple="!pedidoEnviado"
                      @click="!pedidoEnviado ? editarItem(item) : null"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ item.codigo }} {{ item.descricao ? ' - ' + item.descricao : '' }}
                          <span v-if="item.observacao"> - {{ item.observacao }}</span>
                        </v-list-item-title>

                        <v-list-item-subtitle class="mt-1">
                          Qtd: {{ item.quantidade }} | 
                          Preço: {{ formatarValor(item.valorunitario) }}
                        </v-list-item-subtitle>

                        <v-list-item-subtitle class="font-weight-medium">
                          Total: <span> {{ formatarValor(item.subtotal) }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action v-if="!pedidoEnviado">
                        <v-icon color="grey">mdi-chevron-right</v-icon>
                      </v-list-item-action>
                      
                    </v-list-item>

                    <v-divider 
                      v-if="index < itensPedidoAtivos.length - 1" 
                      :key="`divider-${index}`"
                    ></v-divider>
                    
                  </template>
                </v-list>
              </simplebar>
            </v-col>
          </v-row>

        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogCancelar" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmar Cancelamento
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          Deseja realmente sair sem salvar as alterações?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogCancelar = false">Não</v-btn>
          <v-btn color="white" class="primary" text @click="confirmarCancelamento">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExcluir" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmar Exclusão
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          Deseja realmente excluir este pedido?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogExcluir = false">Não</v-btn>
          <v-btn color="white" class="primary" text @click="confirmarExclusao">Sim, Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLocalizacao" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Atenção
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          Localização do dispositivo não encontrada. Deseja continuar e salvar sem a localização?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogLocalizacao = false">Não</v-btn>
          <v-btn color="primary" text @click="confirmarSalvarSemLocalizacao">Sim, Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValidacao" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text text--darken-2">
          Atenção
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Não foi possível salvar o pedido. Verifique os seguintes itens:
          
          <ul class="mt-3 ml-2">
            <li v-for="(msg, index) in mensagensErro" :key="index" class="red--text text--darken-3">
              {{ msg }}
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogValidacao = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRecuperarPedido" max-width="450" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          Pedido Interrompido
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          Encontramos itens de um pedido que foi fechado antes de ser salvo. Estes itens órfãos precisam ser apagados para iniciar um novo pedido.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="descartarPedidoInterrompido">Apagar Itens</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Restrição do Cliente -->
    <v-dialog v-model="dialogConfirmacaoRestricao" max-width="450" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-alert</v-icon>
          Restrição Encontrada
        </v-card-title>
        
        <v-card-text class="pt-4 text-body-1 black--text">
          <p>Este cliente possui a seguinte observação:</p>
          <p class="font-weight-bold">{{ mensagemRestricaoConfirmacao }}</p>
          <p class="mb-0">Deseja manter este cliente no pedido mesmo assim?</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="cancelarSelecaoRestrita">Cancelar</v-btn>
          <v-btn color="primary" depressed @click="confirmarSelecaoRestrita">Sim, Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog de Restrição / Bloqueio do Cliente -->
    <v-dialog v-model="dialogBloqueio" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Atenção</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">{{ motivoBloqueio }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogBloqueio = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';
import geraData from '@/utils/geradata'; 

export default {
  name: 'ViewCadastroPedido',
  components: {
    simplebar,
  },
  
  data() {
    return {
      rotaDestino: '/pedido',
      isOrcamento: false,
      limitesPlano: { 
        min: 0, 
        max: 0, 
        tipo: -1 
        },
      pedidoDexieId: null,
      formData: {
        idpedido: null,
        idpedidoback: null,
        idpedidoditemd: null,
        data: geraData(new Date(), 'DDD/MM/YYYY HH:mm'),
        cliente: null,
        nomeCliente: null,
        tipo: null,
        descricaoTipo: null,
        planoPagamento: null,
        descricaoPlanoPagamento: null,
        formaPagamento: null,
        descricaoFormaPagamento: null,
        destino: null,
        descricaoDestino: null,
        observacao: null,
        atendido: 0,
        idorcamentoback: null,
        orcamento: 0,
        dataconversao: null,
      },
      itensPedido: [],
      loading: false,
      dialogCancelar: false,
      dialogExcluir: false,
      dialogValidacao: false,
      dialogLocalizacao: false,
      dialogBloqueio: false,
      motivoBloqueio: '',
      mensagensErro: [],
      dialogRecuperarPedido: false,
      itensOrfaos: [],
      dialogConfirmacaoRestricao: false,
      mensagemRestricaoConfirmacao: '',
      clientePendenteSelecao: null,
      clienteVindoDaBusca: null,
    };
  },
  
  computed: {
    totalPedido() {
      const total = this.itensPedido
        .filter(item => !item.DT_Cancelado)
        .reduce((acc, item) => {
          const qtd = parseFloat(item.quantidade) || 0;
          const val = parseFloat(item.valorunitario) || 0; 
          const desc = parseFloat(item.valordesconto) || 0;
          const promo = parseFloat(item.vlrpromocaoclube) || 0;
          
          const subtotal = (qtd * (val - desc)) - promo;
          return acc + subtotal;
        }, 0);
      return total.toFixed(2);
    },

    itensPedidoAtivos() {
      return this.itensPedido ? this.itensPedido.filter(item => !item.DT_Cancelado) : [];
    },

    totalQtdItens() {
      return this.itensPedidoAtivos.length;
    },

    totalPedidoFormatado() {
      const valor = parseFloat(this.totalPedido) || 0;
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    pedidoEnviado() {
      if (this.formData.atendido == 1 && this.formData.orcamento == 1) {
        return false;
      }

      return this.formData.atendido == 1;
    },

    idPedidoExibicao() {
      if (this.formData.idpedidoback) {
        return this.formData.idpedidoback;
      }
      if (this.formData.idorcamentoback) {
        return this.formData.idorcamentoback;
      }
      return this.formData.idpedido || '';
    }
  },

  methods: {

    async verificarPedidoInterrompido() {
      try {
        const tabela = db.pedidoitem || db.pedidoItem;
        const todosItens = await tabela.toArray();

        const orfaos = todosItens.filter(i => {
          const idInvalido = !i.idpedido || i.idpedido === null || i.idpedido === '' || i.idpedido === 0 || Number.isNaN(i.idpedido);
          const temVinculo = !!i.idpedidoditemd && i.idpedidoditemd !== '';
          
          if (idInvalido && temVinculo) {
            return true;
          }
          return false;
        });

        if (orfaos.length > 0) {
          this.itensOrfaos = orfaos;
          this.dialogRecuperarPedido = true;
        } else {
          // console.log("3. Nenhum item órfão encontrado.");
        }
      } catch (e) {
        // console.error("Erro ao verificar pedidos interrompidos:", e);
      }
    },

    async descartarPedidoInterrompido() {
      this.dialogRecuperarPedido = false;
      try {
        const tabela = db.pedidoitem || db.pedidoItem;
        const vinculos = [...new Set(this.itensOrfaos.map(i => i.idpedidoditemd))];
        for (const vinculo of vinculos) {
          if (vinculo) {
            await tabela.where('idpedidoditemd').equals(vinculo).delete();
          }
        }
      } catch (e) {
        console.error("Erro ao descartar itens orfãos:", e);
      }
      this.itensOrfaos = [];
    },

  emitirAlteracaoTitulo() {
    const titulo = this.isOrcamento ? 'Cadastro Orçamento' : 'Cadastro Pedido';
    this.$root.$emit('appbar-alterar-titulo', titulo);
  },

  alternarTipoOperacao() {
    this.isOrcamento = !this.isOrcamento;
  },

  tratarVoltarAppBar() {
    this.cancelar(); 
  },

    async inicializar() {
      const temIdClienteNaUrl = this.$route.query.idcliente;
      
      const jaAtualizou = sessionStorage.getItem('forced_reload_check');
      
      if (temIdClienteNaUrl && !jaAtualizou) {
          sessionStorage.setItem('forced_reload_check', 'true');
          console.log("Forçando atualização para carregar cliente da URL...");
          window.location.reload();
          return;
      } else {
          sessionStorage.removeItem('forced_reload_check');
      }

      window.scrollTo(0, 0);

      const temResultadoPesquisa = sessionStorage.getItem('pesquisaResultado');
      const idDaRota = this.$route.query.id || this.$route.query.idPedido || this.$route.query.idpedido;

      const backup = sessionStorage.getItem('pedidoEmEdicao');
      let usarBackup = false;

      if (backup) {
        const backupObj = JSON.parse(backup);
        const idBackup = backupObj.formData ? backupObj.formData.idpedido : null;

        if (idBackup && idDaRota && parseInt(idBackup) == parseInt(idDaRota)) {
            usarBackup = true;
        } 
        else if (!idDaRota && backupObj) {
            usarBackup = true;
        }
        else if (idDaRota && idBackup && parseInt(idBackup) != parseInt(idDaRota)) {
            sessionStorage.removeItem('pedidoEmEdicao');
            usarBackup = false;
        }
      }

      const retornandoDePesquisa = usarBackup || temResultadoPesquisa;

      if (!retornandoDePesquisa) {
        sessionStorage.removeItem('pedidoEmEdicao'); 
        
        if (idDaRota) {
          if (this.formData.idpedido != idDaRota || !this.formData.idpedido) {
            await this.carregarPedido(parseInt(idDaRota, 10)); 
          }
        } else {
          if (!this.formData.idpedido) {
            await this.novoPedido();
            await this.verificarPedidoInterrompido();
          }
        }

        let idClienteInicial = this.$route.query.idcliente;

        if (!idClienteInicial) {
          idClienteInicial = sessionStorage.getItem('retornoIdCliente');
        }

        if (!idClienteInicial) {
          const clienteStorage = sessionStorage.getItem('vendasView_clienteAtual'); 
          if (clienteStorage) {
              try {
                  const dados = JSON.parse(clienteStorage);
                  if (dados && dados.codigo) {
                    idClienteInicial = dados.codigo;
                  }
              } catch(e) {
                //das
              }
          }
        }

        if (idClienteInicial) {
            const idInt = parseInt(idClienteInicial);
            if (idInt && this.formData.cliente !== idInt) {
                this.formData.cliente = idInt;
                this.$nextTick(async () => {
                  if (!this.formData.nomeCliente) {
                      await this.buscarCliente(idInt);
                  }
                });
            }
        }
      } else {
        if (temResultadoPesquisa) {
            await this.verificarRetornoPesquisa();
        }
      }
    },

    garantirPositivo(campo) {
      if (this.formData[campo] < 0) {
        this.formData[campo] = Math.abs(this.formData[campo]);
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    formatarValor(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },

    async irParaImpressao() {
      if (!this.formData.idpedido) {
          this.motivoBloqueio = "Erro: Pedido sem ID.";
          this.dialogBloqueio = true;
          return;
      }
      
      if (this.pedidoEnviado) {
        this.$router.push({ 
            path: '/impressao_pedido', 
            query: { id: this.formData.idpedido } 
        });
        return; 
      }
      await this.salvar('/impressao_pedido'); 
    },

    salvarEstadoTemporario() {
      const estadoAtual = {
        formData: this.formData,
        pedidoDexieId: this.pedidoDexieId,
        isOrcamento: this.isOrcamento
      };
      sessionStorage.setItem('pedidoEmEdicao', JSON.stringify(estadoAtual));
    },

    async verificarRetornoPesquisa() {
      const estadoSalvo = sessionStorage.getItem('pedidoEmEdicao');
      
      if (estadoSalvo) {
        const estado = JSON.parse(estadoSalvo);
        
        this.formData = estado.formData;
        this.pedidoDexieId = estado.pedidoDexieId;

        if (typeof estado.isOrcamento !== 'undefined') {
          this.isOrcamento = estado.isOrcamento;
        }
        
        sessionStorage.removeItem('pedidoEmEdicao'); 
      }

      const idVinculoNovo = sessionStorage.getItem('idPedidoVinculoAtual');
      
      if (idVinculoNovo) {
          if (!this.formData.idpedidoditemd) {
            this.formData.idpedidoditemd = idVinculoNovo;
          }
          sessionStorage.removeItem('idPedidoVinculoAtual');
      }

      const retorno = sessionStorage.getItem('pesquisaResultado');
      
      if (retorno) {
        const data = JSON.parse(retorno);
        
        if (data.tipo === 'Precadastro' || data.isPrecadastro) {
          const lead = data.lead || data.clienteData || {};
          const linhas = [];
          if (lead.cllnome || data.descricao) linhas.push(`Cli: ${lead.cllnome || data.descricao}`);
          
          const doc = lead.cllcnpjCpf ? this.formatarCpfCnpj(lead.cllcnpjCpf) : '';
          const ie = lead.cllrgInscricao && lead.cllrgInscricao !== 'ISENTO' ? ` - IE/RG: ${lead.cllrgInscricao}` : '';
          if (doc) linhas.push(`Doc: ${doc}${ie}`);

          const enderecoPartes = [
            lead.cllendereco,
            lead.cllnumero ? `Nº ${lead.cllnumero}` : '',
            lead.cllbairro,
          ].filter(Boolean).join(', ');

          const cidadeUf = [lead.cllcidade, lead.clluf].filter(Boolean).join('/');
          const localizacao = [enderecoPartes, cidadeUf].filter(Boolean).join(' - ');
          if (localizacao) linhas.push(`End: ${localizacao}`);

          const fone = [lead.clltelefone, lead.cllcelular].filter(Boolean).join(' / ');
          const contato = lead.cllcontato ? `(${lead.cllcontato})` : '';
          if (fone || contato) linhas.push(`Tel: ${fone} ${contato}`.trim());

          const textoPrecadastro = linhas.join('\n');

          const obsAtual = this.formData.observacao || '';
          let resultadoFinal = textoPrecadastro;
          if (obsAtual.trim()) {
            if (!obsAtual.includes('[PRÉ-CADASTRO')) {
              resultadoFinal = `${obsAtual.trim()}\n${textoPrecadastro}`;
            }
          }
          this.formData.observacao = resultadoFinal.substring(0, 250);
        }
        else if (data.tipo === 'Cliente') {
          if (data.restricaoAceita) {
            this.clienteVindoDaBusca = parseInt(data.codigo);
          } else {
            this.clienteVindoDaBusca = null;
          }

          this.formData.cliente = data.codigo;
          this.formData.nomeCliente = data.descricao;
        }
        else if (data.tipo === 'Tipo de Pagamento') {
          this.formData.tipo = data.codigo;
          this.formData.descricaoTipo = data.descricao;
          this.buscarTipo(data.codigo, true);
        }
        else if (data.tipo === 'Plano de Pagamento') {
          this.formData.planoPagamento = data.codigo;
          this.formData.descricaoPlanoPagamento = data.descricao;
        }
        else if (data.tipo === 'Forma de Pagamento') {
          this.formData.formaPagamento = data.codigo;
          this.formData.descricaoFormaPagamento = data.descricao;
        }
        else if (data.tipo === 'Destino da Mercadoria') {
          this.formData.destino = data.codigo;
          this.formData.descricaoDestino = data.descricao;
        }

        sessionStorage.removeItem('pesquisaResultado');
      }

      if (this.formData.idpedido || this.formData.idpedidoditemd) {
        await this.carregarItens(this.formData.idpedido);
        
        if (this.formData.idpedido && !this.formData.idpedidoditemd) {
          try {
            const tabela = db.pedidoitem;
            const itemComVinculo = await tabela
              .where('idpedido').equals(parseInt(this.formData.idpedido))
              .filter(i => !!i.idpedidoditemd) 
              .first();
            if (itemComVinculo) {
              this.formData.idpedidoditemd = itemComVinculo.idpedidoditemd;
            }
          } catch (e) {
            // console.error("Erro ao tentar recuperar vínculo do banco:", e);
          }
        }
      }
    },

    async carregarPedido(id) {
      this.loading = true;
      try {
        let pedido = await db.pedido.get(id);

        if (!pedido) {
          pedido = await db.pedido.where('idpedido').equals(id).first();
        }

        if (!pedido) {
          pedido = await db.pedido.where('idpedidoback').equals(id).first();
        }

        if (!pedido) {
          pedido = await db.pedido.where('idpedidoback').equals(String(id)).first();
        }

        if (pedido) {
          this.pedidoDexieId = pedido.idpedido; 
          this.formData.idpedido = pedido.idpedido || pedido.id; 
          this.formData.idpedidoback = pedido.idpedidoback || null;
          this.formData.idpedidoditemd = pedido.idpedidoditemd;
          
          this.formData.data = geraData(new Date(pedido.data), 'DD/MM/YYYY HH:mm');

          this.isOrcamento = (pedido.orcamento === 1);
          this.formData.orcamento = pedido.orcamento;
          
          this.formData.cliente = pedido.idcliente;        
          this.formData.tipo = pedido.idtipopedidovenda;   
          this.formData.planoPagamento = pedido.idplanopagto;
          this.formData.formaPagamento = pedido.idformapagto; 
          this.formData.destino = pedido.iddestinoitem; 
          
          this.formData.observacao = pedido.observacao;
          this.formData.atendido = pedido.atendido;
          this.formData.idorcamentoback = pedido.idorcamentoback;
          this.formData.dataconversao = pedido.dataconversao || null;

          await this.carregarItens(pedido.idpedido || pedido.id);

        } else {
            this.formData.idpedido = id;
            await this.carregarItens(id);
        }
      } catch (error) {
        console.error("Erro ao carregar pedido:", error);
      } finally {
        this.loading = false;
      }
    },

    async carregarItens(idPedido) {
      if (!idPedido && !this.formData.idpedidoditemd) return;
      
      try {
        const tabela = db.pedidoitem || db.pedidoItem;
        
        let itens = [];
        if (idPedido) {
          itens = await tabela.where('idpedido').equals(parseInt(idPedido, 10)).toArray();

          if (itens.length === 0) {
            itens = await tabela.where('idpedido').equals(String(idPedido)).toArray();
          }
        }

        if (itens.length === 0 && this.formData.idpedidoditemd) {          
          try {
            itens = await tabela.where('idpedidoditemd').equals(this.formData.idpedidoditemd).toArray();
          } catch (e) {
            itens = await tabela.filter(i => i.idpedidoditemd == this.formData.idpedidoditemd).toArray();
          }
        }

        this.itensPedido = await Promise.all(
          itens.map(async (item) => {
            const idReal = item.idpedidoitem || item.id; 
            
            let descricaoProduto = item.descricao && item.descricao.trim() ? item.descricao : null;

            if (item.idcortamanhofinal && db.produto) {
              const idLimpo = String(item.idcortamanhofinal).trim();
              const idNum = !isNaN(idLimpo) ? parseInt(idLimpo, 10) : null;
              let prod = null;

              if (!descricaoProduto) {
                if (idNum !== null) {
                  prod = await db.produto.where('idcortamanhofinal').equals(idNum).first();
                }
                if (!prod) {
                  prod = await db.produto.where('idcortamanhofinal').equals(idLimpo).first();
                }

                if (!prod && idNum !== null) {
                  prod = await db.produto.get(idNum);
                }
                if (!prod) {
                  prod = await db.produto.get(idLimpo);
                }

                if (prod && prod.descricao && prod.descricao.trim()) {
                  descricaoProduto = prod.descricao;
                } else {
                  descricaoProduto = `Cód. ${idLimpo}`;
                }
              }
            } else if (!descricaoProduto) {
              descricaoProduto = 'Produto sem nome';
            }

            return {
              id: idReal,
              idPedidoItem: idReal,
              codigo: item.idcortamanhofinal, 
              descricao: descricaoProduto,
              quantidade: item.quantidade,
              valorunitario: item.valorunitario,
              valordesconto: item.valordesconto || 0,
              vlrpromocaoclube: item.vlrpromocaoclube || 0,
              DT_Cancelado: item.DT_Cancelado, 
              subtotal: (item.quantidade * (item.valorunitario - (item.valordesconto || 0))) - (item.vlrpromocaoclube || 0)
            };
          })
        );

      } catch (error) {
        console.error("Erro ao carregar itens na lista:", error);
      }
    },

    async novoPedido() {
      sessionStorage.removeItem('idPedidoVinculoAtual');
      sessionStorage.removeItem('pedidoEmEdicao');
      sessionStorage.removeItem('pesquisaResultado');
      sessionStorage.removeItem('itensVisuaisLaranja');
      sessionStorage.removeItem('pedidoAtualItens');
      this.isOrcamento = false;

      this.formData.idpedido = null;
      this.formData.idpedidoback = null;
      this.formData.idpedidoditemd = null; 
      this.formData.data = geraData(new Date(), 'DD/MM/YYYY HH:mm');
      this.itensPedido = []; 
      this.formData.cliente = null;
      this.formData.nomeCliente = null;
      this.formData.tipo = null;
      this.formData.descricaoTipo = null;
      this.formData.planoPagamento = null;
      this.formData.descricaoPlanoPagamento = null;
      this.formData.formaPagamento = null;
      this.formData.descricaoFormaPagamento = null;
      this.formData.destino = null;
      this.formData.descricaoDestino = null;
      this.formData.observacao = null;
      this.formData.atendido = 0;
      this.formData.orcamento = 0;
    },

    getTextoRestricao(item) {
      if (!item) return null;
      const restricao = item.restricao ? item.restricao.trim() : '';
      const codigoRestricao = restricao.length > 0 ? restricao.substring(0, 1) : '';
      
      let msg = '';
      switch (codigoRestricao) {
        case '0': msg = "Cliente Inativo."; break;
        case '1': msg = "Ficha cadastral não aprovada."; break;
        case '2': msg = "LIMITE DE CRÉDITO EXCEDIDO."; break;
        case '3': msg = "Parcela Primeira Compra Aberta."; break;
        case '4': msg = "Financeiro em Atraso."; break;
        case '5': msg = "Cliente com Restrição SPC."; break;
        case '6': msg = "Cliente Bloqueado."; break;
        case '7': msg = "Limite de Crédito Autorizado Excedido."; break;
        case '9': msg = "Cliente possui pré-venda aberta."; break;
        default:
          if (codigoRestricao === 'N' || codigoRestricao === '') return null;
          msg = restricao;
          break;
      }
      return msg;
    },

    async buscarCliente(valor) {
      const idNum = parseInt(valor);
      
      if (!valor) {
        this.formData.nomeCliente = ''; 
        return;
      }

      try {
        let cliente = await db.cliente.where('idcliente').equals(idNum).first();

        if (!cliente) {
            cliente = await db.cliente.where('idcliente').equals(String(idNum)).first();
        }
        if (!cliente) {
          cliente = await db.cliente.get(idNum);
        }

        if (cliente) {
          if (cliente.bloqueado === 'S') {
            this.motivoBloqueio = 'Cliente Bloqueado!';
            this.dialogBloqueio = true;
            this.formData.cliente = null;
            this.formData.nomeCliente = '';
            return;
          }

          if (this.clienteVindoDaBusca && parseInt(this.clienteVindoDaBusca) === parseInt(idNum)) {
            this.vincularDadosCliente(cliente);
            this.clienteVindoDaBusca = null;
            return;
          }

          const restricao = cliente.restricao ? cliente.restricao.trim() : '';
          const char0 = restricao.length > 0 ? restricao.substring(0, 1) : 'N';
          const char1 = restricao.length > 1 ? restricao.substring(1, 2) : '';

          const msgRestricao = this.getTextoRestricao(cliente);

          if (char0 !== 'N' && char1 === 'N') {
            this.motivoBloqueio = msgRestricao || 'Cliente possui restrição e não pode ser selecionado.';
            this.dialogBloqueio = true;
            this.formData.cliente = null;
            this.formData.nomeCliente = '';
            return;
          }

          if (char0 !== 'N' && char1 === 'S') {
            if (msgRestricao && (!this.clientePendenteSelecao || this.clientePendenteSelecao.idcliente !== cliente.idcliente)) {
              this.clientePendenteSelecao = cliente;
              this.mensagemRestricaoConfirmacao = msgRestricao;
              this.dialogConfirmacaoRestricao = true;
              return;
            }
          }

          this.vincularDadosCliente(cliente);

        } else {
          this.formData.nomeCliente = "Cliente não encontrado";
        }
      } catch (error) {     
        if (error.name === 'InvalidTable' || error.message.includes('Index')) {
            this.motivoBloqueio = "Erro de Banco de Dados: O índice 'idcliente' não existe. Por favor, limpe os dados do aplicativo.";
            this.dialogBloqueio = true;
        }
        this.formData.nomeCliente = "Erro no Banco";
      }
    },

    vincularDadosCliente(cliente) {
      this.formData.nomeCliente = cliente.nome;

      const idPlano = cliente.idplanopagto || cliente.idPlanopagto;
      const idForma = cliente.idforma || cliente.idForma || cliente.idformapagto;

      if (idPlano && !this.formData.planoPagamento) {
          this.formData.planoPagamento = idPlano;
          this.buscarPlanoPagamento(idPlano);
      }
      if (idForma && !this.formData.formaPagamento) {
          this.formData.formaPagamento = idForma;
          this.buscarFormaPagamento(idForma);
      }
    },

    confirmarSelecaoRestrita() {
      if (this.clientePendenteSelecao) {
        this.clienteVindoDaBusca = parseInt(this.clientePendenteSelecao.idcliente);
        
        this.vincularDadosCliente(this.clientePendenteSelecao);
        this.dialogConfirmacaoRestricao = false;
        this.clientePendenteSelecao = null;
      }
    },

    cancelarSelecaoRestrita() {
      this.dialogConfirmacaoRestricao = false;
      this.clientePendenteSelecao = null;
      this.formData.cliente = null;
      this.formData.nomeCliente = '';
    },

    async buscarTipo(valor, isManualChange = false) {
      const id = parseInt(valor);
      if (!id || isNaN(id)) {
        this.formData.descricaoTipo = '';
        return;
      }

      try {
        const tipo = await db.tipopedidovenda.where('idtipopedidovenda').equals(id).first();
        
        if (tipo) {
          this.formData.descricaoTipo = tipo.descricao;
          
          if (isManualChange) {
            if (tipo.idplanopagto && !this.formData.planoPagamento) {
              this.formData.planoPagamento = tipo.idplanopagto;
            }
            if (tipo.idformapagto && !this.formData.formaPagamento) {
              this.formData.formaPagamento = tipo.idformapagto;
            }
            if (tipo.iddestinoitem && !this.formData.destino) {
              this.formData.destino = tipo.iddestinoitem;
            }
          }
        } else {
          this.formData.descricaoTipo = "Tipo não encontrado";
        }
      } catch (error) {
        // console.error("Erro no Dexie (Tipo):", error);
      }
    },

    async buscarPlanoPagamento(valor) {
      const id = parseInt(valor);
      if (!id) return;
      try {
          const item = await db.planopagamento.where('idplanopagto').equals(id).first();
          this.formData.descricaoPlanoPagamento = item ? item.descricao : "Plano não encontrado";
      } catch (e) { console.error(e); }
    },

    async buscarFormaPagamento(valor) {
      const id = parseInt(valor);
      if (!id) return;
      try {
          const item = await db.formapagto.where('idformapagto').equals(id).first();
          this.formData.descricaoFormaPagamento = item ? item.descricao : "Forma não encontrada";
      } catch (e) { console.error(e); }
    },

    async buscarDestino(valor) {
      const id = parseInt(valor);
      if (!id) return;
      try {
          const item = await db.destinoitem.where('iddestinoitem').equals(id).first();
          this.formData.descricaoDestino = item ? item.descricao : "Destino não encontrado";
      } catch (e) { console.error(e); }
    },

    async salvar(destino) {
      if (typeof destino !== 'string') {
        destino = '/pedido';
      }
      this.rotaDestino = destino;

      if (this.pedidoEnviado) {
        this.motivoBloqueio = "Este pedido já foi enviado e não pode ser alterado.";
        this.dialogBloqueio = true;
        return;
      }
      
      this.mensagensErro = [];
      if (!this.itensPedido || this.itensPedido.length === 0) {
        this.mensagensErro.push("É necessário adicionar pelo menos um item ao pedido.");
      }
      if (!this.formData.cliente) {
        this.mensagensErro.push("Informe o Cliente.");
      } else if (!this.formData.nomeCliente || this.formData.nomeCliente === 'Cliente não encontrado' || this.formData.nomeCliente === 'Erro no Banco') {
        this.mensagensErro.push("O Cliente informado não existe.");
      }

      if (!this.isOrcamento) {
        if (!this.formData.tipo) {
          this.mensagensErro.push("Informe o Tipo do Pedido.");
        } else if (!this.formData.descricaoTipo || this.formData.descricaoTipo === 'Tipo não encontrado') {
          this.mensagensErro.push("O Tipo de Pedido informado não existe.");
        }

        if (!this.formData.planoPagamento) {
          this.mensagensErro.push("Informe o Plano de Pagamento.");
        } else if (!this.formData.descricaoPlanoPagamento || this.formData.descricaoPlanoPagamento === 'Plano não encontrado') {
          this.mensagensErro.push("O Plano de Pagamento informado não existe.");
        }

        if (!this.formData.formaPagamento) {
          this.mensagensErro.push("Informe a Forma de Pagamento.");
        } else if (!this.formData.descricaoFormaPagamento || this.formData.descricaoFormaPagamento === 'Forma não encontrada') {
          this.mensagensErro.push("A Forma de Pagamento informada não existe.");
        }

        if (!this.formData.destino) {
          this.mensagensErro.push("Informe o Destino.");
        } else if (!this.formData.descricaoDestino || this.formData.descricaoDestino === 'Destino não encontrado') {
          this.mensagensErro.push("O Destino informado não existe.");
        }

      } else {
        if (this.formData.tipo && (!this.formData.descricaoTipo || this.formData.descricaoTipo === 'Tipo não encontrado')) {
          this.mensagensErro.push("O Tipo de Pedido informado não existe.");
        }
        if (this.formData.planoPagamento && (!this.formData.descricaoPlanoPagamento || this.formData.descricaoPlanoPagamento === 'Plano não encontrado')) {
          this.mensagensErro.push("O Plano de Pagamento informado não existe.");
        }
        if (this.formData.formaPagamento && (!this.formData.descricaoFormaPagamento || this.formData.descricaoFormaPagamento === 'Forma não encontrada')) {
          this.mensagensErro.push("A Forma de Pagamento informada não existe.");
        }
        if (this.formData.destino && (!this.formData.descricaoDestino || this.formData.descricaoDestino === 'Destino não encontrado')) {
          this.mensagensErro.push("O Destino informado não existe.");
        }
      }
      
      const valorTotal = parseFloat(this.totalPedido.replace(',', '.')); 
      if (this.limitesPlano && this.limitesPlano.tipo !== 0) { 
        const min = this.limitesPlano.min || 0;
        const max = this.limitesPlano.max || 0;
        
        if (valorTotal < min) {
            this.mensagensErro.push(`Valor abaixo do mínimo permitido (R$ ${min.toFixed(2)}).`);
        }
        if (max > 0 && valorTotal > max) {
            this.mensagensErro.push(`Valor acima do máximo permitido (R$ ${max.toFixed(2)}).`);
        }
      }

      if (this.mensagensErro.length > 0) {
        this.dialogValidacao = true;
        return; 
      }
      
      if (!this.formData.idpedidoditemd) {
         this.formData.idpedidoditemd = 'P-' + Date.now().toString() + Math.floor(Math.random() * 1000);
      }

      const position = await this._obterLocalizacao();

      if (position) {
        // console.log("Localização definida para salvar:", position.coords.latitude, position.coords.longitude);
        this.finalizarSalvar(position.coords.latitude, position.coords.longitude, destino || '/pedido');
      } else {
        this.dialogLocalizacao = true;
      }
    },

    _obterLocalizacao() {
      return new Promise((resolve) => {
        const latStore = localStorage.getItem('msUtil_latitude');
        const lngStore = localStorage.getItem('msUtil_longitude');

        if (latStore && lngStore) {
          resolve({ 
            coords: { 
              latitude: parseFloat(latStore), 
              longitude: parseFloat(lngStore) 
            }
          });
          return;
        }

        console.warn("Sem cache no Storage, tentando hardware direto...");
        if (!navigator.geolocation) {
          resolve(null);
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos),
          (err) => {
            console.error("Erro GPS Pedido:", err);
            resolve(null);
          },
          { timeout: 5000, enableHighAccuracy: false }
        );
      });
    },

    confirmarSalvarSemLocalizacao() {
      this.dialogLocalizacao = false;
      this.finalizarSalvar(0, 0);
    },

    async finalizarSalvar(latitude, longitude) {
      let idVendedor = null;
      try {
        const paramsDb = await db.parametro.toArray();
        if (paramsDb.length > 0) {
          idVendedor = paramsDb[0].idvendedorlogado; 
        }
      } catch (e) {
        console.error("Erro ao recuperar vendedor logado:", e);
      }

      if (!this.pedidoDexieId && !this.formData.idpedido) {
        try {
          const ultimoPedido = await db.pedido.orderBy('idpedido').last();
          this.formData.idpedido = ultimoPedido ? Number(ultimoPedido.idpedido) + 1 : 1;
        } catch (error) {
          this.formData.idpedido = 1;
        }
      }

      const valorTotal = parseFloat(this.totalPedido.replace(',', '.')); 

      const tzoffset = (new Date()).getTimezoneOffset() * 60000;
      const dataHoraLocal = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

      const pedidoData = {
        idpedido: this.formData.idpedido,
        ...(this.formData.idpedidoback ? { idpedidoback: this.formData.idpedidoback } : {}),
        data: this.formData.dataOriginal ? this.formData.dataOriginal : dataHoraLocal,
        orcamento: this.isOrcamento ? 1 : 0,
        idformapagto: this.formData.formaPagamento,
        iddestinoitem: this.formData.destino,
        idcliente: this.formData.cliente,
        idplanopagto: this.formData.planoPagamento,
        idtipopedidovenda: this.formData.tipo,
        observacao: this.formData.observacao,
        atendido: 0,
        idpedidoditemd: this.formData.idpedidoditemd,
        total: valorTotal,
        idvendedor: idVendedor,
        sync: 0,
        dataconversao: this.formData.dataconversao
      };

      try {
        if (this.pedidoDexieId) {
          await db.pedido.update(this.pedidoDexieId, pedidoData);

          if (!this.isOrcamento) {
            try {
              const visitaAssociada = await db.visita
              .filter(v => parseInt(v.idpedido) === parseInt(this.formData.idpedido))
              .first();

              if (visitaAssociada) {
                await db.visita.update(visitaAssociada.id || visitaAssociada.idvisita, { atendido: 0 });
                console.log(`Visita ID ${visitaAssociada.id || visitaAssociada.idvisita} atualizada para atendido = 0`);
              }
            } catch (visitaError) {
              console.error("Erro ao atualizar o atendido na tabela de visita:", visitaError);
            }
          }

        } else {
          const novoId = await db.pedido.add(pedidoData);
          await db.pedido.update(novoId, { idpedido: novoId });
          this.pedidoDexieId = novoId; 
          
          if (this.formData.idpedidoditemd) {
            try {
              const tabelaItens = db.pedidoitem || db.pedidoItem;
              await tabelaItens
                .where('idpedidoditemd')
                .equals(this.formData.idpedidoditemd)
                .modify({ idpedido: novoId });
            } catch(e) { 
              console.error("Erro ao vincular itens no salvamento final:", e); 
            }
          }
          
          const visitaData = {
            atendido: 0,
            latitude: latitude,
            longitude: longitude,
            datadigitacao: dataHoraLocal,
            datavisita: dataHoraLocal,
            idcliente: this.formData.cliente,
            idpedido: novoId,
            motivo: 4, 
            idvendedor: idVendedor,
            observacao: "OK",
            sync: 0
          };
          
          await db.visita.add(visitaData);
        }

        sessionStorage.removeItem('pedidoEmEdicao');
        sessionStorage.removeItem('idPedidoVinculoAtual');
        sessionStorage.removeItem('pesquisaResultado');
        sessionStorage.removeItem('itensVisuaisLaranja');
        sessionStorage.removeItem('pedidoAtualItens');
        sessionStorage.removeItem('retornoIdCliente'); 
        this.itensPedido = [];
        this.formData = {};

        const destino = this.rotaDestino || '/pedido';

        if (destino === '/impressao_pedido') {
            this.$router.replace({ 
              path: destino, 
              query: { id: this.pedidoDexieId } 
            });
        } else {
            this.$router.replace({ 
              path: '/pedido',
            });
        }

      } catch (error) {
        console.error("Erro ao salvar pedido:", error);
        this.motivoBloqueio = "Ocorreu um erro ao salvar o pedido.";
        this.dialogBloqueio = true;
      }
    },

    cancelar() {
      if (this.pedidoEnviado) {
        this.confirmarCancelamento();
        return;
      }
      const temDadosPreenchidos = 
        this.formData.cliente || 
        this.formData.tipo || 
        this.formData.planoPagamento || 
        this.formData.formaPagamento || 
        this.formData.destino || 
        (this.formData.observacao && this.formData.observacao.trim() !== '') ||
        this.itensPedido.length > 0;

      if (temDadosPreenchidos) {
        this.dialogCancelar = true;
      } else {
        this.confirmarCancelamento();
      }
    },

    async confirmarCancelamento() { 
      this.dialogCancelar = false;
      
      try {
        if (!this.pedidoDexieId) {
            const tabelaItens = db.pedidoitem || db.pedidoItem;
            
            if (this.formData.idpedido) {
                const idNum = parseInt(this.formData.idpedido);
                await tabelaItens.where('idpedido').equals(idNum).delete();
                await tabelaItens.where('idpedido').equals(String(idNum)).delete();
            }

            if (this.formData.idpedidoditemd) {
                await tabelaItens.where('idpedidoditemd').equals(this.formData.idpedidoditemd).delete();
            }

        }

      } catch (error) {
        console.error("Erro ao limpar dados do pedido ao cancelar:", error);
      }

      sessionStorage.removeItem('pedidoEmEdicao'); 
      sessionStorage.removeItem('pesquisaResultado');
      sessionStorage.removeItem('idPedidoVinculoAtual');
      sessionStorage.removeItem('itensVisuaisLaranja');
      sessionStorage.removeItem('pedidoAtualItens');
      sessionStorage.removeItem('retornoIdCliente'); 
      
      this.$router.replace({ 
              path: '/pedido',
            });
    },

    excluir() {
      if (this.pedidoEnviado) return;
      this.dialogExcluir = true;
    },

    async confirmarExclusao() {
      this.dialogExcluir = false;
      
      if (!this.pedidoDexieId) {
        return;
      }

      try {
        const tabelaItens = db.pedidoitem || db.pedidoItem;
        
        if (this.formData.idpedido) {
            const idNum = parseInt(this.formData.idpedido);
            await tabelaItens.where('idpedido').equals(idNum).delete();
            
            await tabelaItens.where('idpedido').equals(String(idNum)).delete();
        }

        if (this.formData.idpedidoditemd) {
            await tabelaItens.where('idpedidoditemd').equals(this.formData.idpedidoditemd).delete();
        }

        await db.pedido.delete(this.pedidoDexieId);
        
        sessionStorage.removeItem('pedidoEmEdicao');
        sessionStorage.removeItem('pesquisaResultado');
        sessionStorage.removeItem('idPedidoVinculoAtual');
        sessionStorage.removeItem('itensVisuaisLaranja');
        sessionStorage.removeItem('pedidoAtualItens');
        sessionStorage.removeItem('retornoIdCliente'); 

        this.$router.replace({ 
            path: '/pedido',
          });

      } catch (error) {
        console.error("Erro ao excluir:", error);
        this.motivoBloqueio = "Ocorreu um erro ao excluir o pedido e seus itens.";
        this.dialogBloqueio = true;
      }
    },


    formatarCpfCnpj(valor) {
      if (!valor) return '';
      const digitos = valor.replace(/\D/g, '');
      if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      return valor;
    },

    pesquisarCliente() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/pesquisa-cadastro-cliente', query: { tipo: 'Cliente' } });
    },
    importaCliente() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/listaprecadastro', query: { origem: 'pedido' } });
    },
    pesquisarTipo() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/pesquisa-cadastro-pedido', query: { tipo: 'Tipo de Pagamento', idReferencia: 1 } });
    },
    pesquisarPlanoPagamento() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/pesquisa-cadastro-pedido', query: { tipo: 'Plano de Pagamento', idReferencia: 2 } });
    },
    pesquisarFormaPagamento() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/pesquisa-cadastro-pedido', query: { tipo: 'Forma de Pagamento', idReferencia: 3 } });
    },
    pesquisarDestino() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/pesquisa-cadastro-pedido', query: { tipo: 'Destino da Mercadoria', idReferencia: 4 } });
    },
    editarItem(item) {
      if (this.pedidoEnviado) return;
      this.salvarEstadoTemporario();
      this.$router.push({ 
        path: '/cadastro-pedido-item',
        query: { 
          id: item.id, 
        }
      });
    },

    adicionarItem() {
      this.mensagensErro = [];
      if (!this.formData.cliente || !this.formData.nomeCliente || this.formData.nomeCliente === 'Cliente não encontrado' || this.formData.nomeCliente === 'Erro no Banco') {
        this.mensagensErro.push("É obrigatório informar um cliente válido antes de adicionar itens ao pedido.");
        this.dialogValidacao = true;
        return;
      }

      if (!this.formData.idpedidoditemd) {
        this.formData.idpedidoditemd = 'P-' + Date.now().toString() + Math.floor(Math.random() * 1000);
      }
      
      sessionStorage.setItem('idPedidoVinculoAtual', this.formData.idpedidoditemd);
      if (this.formData.idpedido) {
        sessionStorage.setItem('retornoIdPedido', this.formData.idpedido);
      }
      if (this.formData.cliente) {
        sessionStorage.setItem('retornoIdCliente', this.formData.cliente);
      }

      this.salvarEstadoTemporario();

      this.$router.push({ 
        path: '/cadastro-pedido-produto',
        query: { 
          idpedido: this.formData.idpedido || '',
          idpedidoditemd: this.formData.idpedidoditemd,
          idcliente: this.formData.cliente,
          nomecliente: this.formData.nomeCliente
        }
      });
    },
  },
  
  async created() {
    sessionStorage.removeItem('produto_selecionado_retorno');
    await this.inicializar();
      this.$root.$on('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
      
      this.emitirAlteracaoTitulo();
  },

  beforeDestroy() {
    this.$root.$off('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
  },

  async activated() {
    await this.inicializar();
    this.emitirAlteracaoTitulo(); 
  },

  mounted() {
    if (this.$route.query.isOrcamento !== undefined) {
      this.isOrcamento = this.$route.query.isOrcamento === 'true' || this.$route.query.isOrcamento === true; 
    }
    
    this.verificarRetornoPesquisa();
  },

  watch: {
      isOrcamento(novoValor) {
      this.emitirAlteracaoTitulo();
      this.formData.orcamento = novoValor ? 1 : 0; 

      if (novoValor === false && this.formData.atendido == 1) {
        this.formData.atendido = 0;
      }

      if (novoValor === false) {
      const tzoffset = (new Date()).getTimezoneOffset() * 60000;
      const dataHoraLocal = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
      
      this.formData.dataconversao = dataHoraLocal;
    } else if (novoValor === true) {
      this.formData.dataconversao = null;
    }

      const queryAtual = String(this.$route.query.isOrcamento);
      const novoValorStr = String(novoValor);
      
      if (queryAtual !== novoValorStr) {
        this.$router.replace({ 
          query: { ...this.$route.query, isOrcamento: novoValor } 
        }).catch(() => {});
      }
    },
    'formData.cliente': function(newId) {
      if (newId) {
        this.buscarCliente(newId);
      } else {
        this.formData.nomeCliente = null;
      }
    },
    'formData.tipo': function(newId) {
      if (newId) {
        this.buscarTipo(newId);
      } else {
        this.formData.descricaoTipo = null;
      }
    },
    'formData.planoPagamento': function(newId) {
      if (newId) {
        this.buscarPlanoPagamento(newId);
      } else {
        this.formData.descricaoPlanoPagamento = null;
      }
    },
    'formData.formaPagamento': function(newId) {
      if (newId) {
        this.buscarFormaPagamento(newId);
      } else {
        this.formData.descricaoFormaPagamento = null;
      }
    },
    'formData.destino': function(newId) {
      if (newId) {
        this.buscarDestino(newId);
      } else {
        this.formData.descricaoDestino = null;
      }
    },
  },
};
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
  padding: 32px 16px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.lista-itens-container {
  max-height: 400px; 
  border: 1px solid #eee;
  border-radius: 4px;
}

.lista-itens-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.lista-itens-container ::v-deep .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}

.v-cardt{
  padding-top: 5px;
}

.v-card {
  max-width: 900px;
  width: 100%;
}

.v-subheader {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 8px;
}

.v-form .v-row {
  margin-bottom: 4px;
}

.col-codigo {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-botao {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}
.col-descricao {
  padding-left: 18px;
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.switch-pedido-ativo ::v-deep .v-input--switch__track {
  color: #9dafd1 !important;
  opacity: 0.6;
}

.switch-pedido-ativo ::v-deep .v-input--switch__thumb {
  color: #4c6faf !important;
}

.switch-pedido-ativo ::v-deep .v-input--selection-controls__ripple {
  color: #728ec2 !important;
}

@media (min-width: 600px) {
  .col-codigo {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-botao {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-descricao {
    margin-left: 0;
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}

.btn-adicionar-item {
  height: 42px !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.card-total-pedido {
  background-color: #ffffff;
  border: 1px solid #a4bdeb;
  border-left: 5px solid #4c6faf;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  height: 42px;
  width: 100%;
  transition: border-color 0.2s ease, border-left-color 0.2s ease;
}

.card-total-pedido.card-total-orcamento {
  border: 1px solid #ffe082;
  border-left: 5px solid #ffa000;
}

.label-total {
  font-size: 0.65rem;
  letter-spacing: 0.5px;
  line-height: 1.1;
  white-space: nowrap;
}

.qtd-itens {
  font-size: 0.7rem;
  line-height: 1.1;
  white-space: nowrap;
}

.valor-total {
  font-size: 1.15rem;
  font-weight: 800;
  color: black;
  letter-spacing: -0.5px;
  white-space: nowrap;
}

.empty-itens-box {
  background-color: #fafafa;
  border: 1px dashed #bdbdbd;
  border-radius: 6px;
}
</style>